// @flow

// Ensure a user entered URL ends with a / if not then add one
const ensureUrl = (url: string) => {
  if (url && url.slice(-1) === '/') {
    return url;
  }
  return `${url}/`;
};

export default ensureUrl;
